import { select, useSpadeSdk } from '@ps/web-core-store';
import React, { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import type { Selector } from 'react-redux';

import type { RootState } from '@swf/core/store';

const getCashGamesPath = (pathname: string) => {
  switch (pathname) {
    case '/poker/play-poker/cash-games/simple/omaha/':
      return 'omaha';
    case '/poker/play-poker/cash-games/all-in/':
      return 'all-in';
    default:
      return 'holdem';
  }
};

const SpadeCashGames: React.FC = () => {
  const spadeSdk = useSpadeSdk();
  const unloadRef = useRef<{ unload: () => void }>();
  const pathname = useSelector(select.location.stripPrefix as Selector<RootState, string>);
  const initialPathRef = useRef<ReturnType<typeof getCashGamesPath>>(getCashGamesPath(pathname));

  const loadSpadeCashGames = useCallback(async () => {
    unloadRef.current = await spadeSdk?.load({
      view: 'cash-games',
      element: '#spade-cash-games',
      path: initialPathRef.current
    });
  }, [spadeSdk]);

  useEffect(() => {
    loadSpadeCashGames();

    return () => {
      unloadRef.current?.unload?.();
    };
  }, [loadSpadeCashGames]);

  return <div id="spade-cash-games" style={{ minHeight: 600, display: 'flex' }} />;
};

export default SpadeCashGames;
